export const SWEDISH_TRANSLATIONS = {
  hellovue: {
    frontpage: "Framsida",
    site: {
      name: "Liferay Hello Vue (SV)",
    },
    dropdown: {
      select_language: "Välj språk",
      change_type: 'Vaihda talotyyppi SV'
    },
    sidenav: {
      close:  "Stäng undermenyn", 
      change_view: "Vaihda näkymä SV",
      street_view: "Katunäkymä SV",
      cut_view: "Poikkileikkausnäkymä SV",
    },
    view: {
      street_view: 'katunakyma_sv',
      cross_section_view: 'poikkileikkausnakyma_sv'
    },
    pov_of_educational_buildings: "Oppimisen tilojen poikkileikkausnäkymät",
    buildings: "Rakennukset",
    maincontent: {
      back_to_frontpage: "Takaisin listaussivulle",
      back_to_buildings: "Takaisin rakennuksiin",
      move_to_cross_section_view: "Siirry poikkileikkausnäkymään"
    },
    header:{
      street_view_of_learning_facilities: "Oppilaitosten katunäkymä"
    }
  },
};
